import styled from "styled-components";

export const StyledSubscribe = styled.div`
   padding-bottom: 100px;
  background: #F4F6FC;
   place-items: center; 
  position: relative;
 
    .blue{
        position: absolute;
        top: 0px;
        right: 80px
      }
    
   
    .subscribe__content{
      
      margin-top: -420px;
      
        .subscribe__header{
          margin-bottom: 50px;
           /* text-align: center; */
          place-items: center;

              .subscribe__title{
              font-weight: 800;
              font-size: 53px;
              line-height: 80px;
              text-align: center;
              color: #080055;
              }
              .subscribe__title:hover {
                
  -webkit-transition: color 1s ease;
  -moz-transition: color 1s ease;
  -ms-transition: color 1s ease;
  -o-transition: color 1s ease;
  transition: color 1s ease;
  cursor: pointer;
}
              p{
                font-weight: 400;
                font-size: 18px;
                line-height: 32px;
                text-align: center;
                color: #18191F;
              }
        }

        .subscribe__center{
           
             display: flex;
             align-items: center;
             justify-content: center;
          p{
           padding: 8px;
            font-weight: 400;
            font-size: 18px;
            line-height: 20px;
            color: #18191F;
          }
        
          .year{
            color: #858F97;
            padding: 8px;
          }
        }
       
        .subscribe__plan{
          
        /* margin-left: 90px; */
           display: flex;
           border-radius: 15px; 
           flex-direction: row;
           align-items: center;
           justify-content: center;
           gap: 20px;
           margin: 30px 70px;
           padding-top: 70px;
            
          .subscribe__list{
             
               .subscribe__planGrid{
                
                  border: 1px solid rgba(160, 169, 176, 0.5);
                  border-radius: 15px;
                  padding:  10px;
                  background: #FFF; 

                  
                  p{
                    padding: 10px;
                  }
                   
                  .subscribe_payment{
                    

                  .subscribe__desc{
                    text-align: center;
                      p{
                         font-weight: 400;
                    font-size: 22px;
                    line-height: 20px;
                    letter-spacing: -0.04em;
                    color: #18191F;}
                      main{
                        margin: 0 auto;
                        margin-bottom: 5px;
                            width: 35px;
                        align-items: center;
                        border: 3px solid #377DFF;
                              border-radius: 8px;
                      }
                  }
                  .price{
                    margin: 30px auto;
                      width: 100px;
                      height:100px;
                      border-radius:50px;
                      padding: 10px;
                      text-align: center;
                                 
                         strong{
                              padding:5px 18px;
                              font-weight: 600;
                              font-size: 24px;
                              line-height: 48px;
                            color: white;
                          }
                              p{
                                padding: 1px 10px;
                        font-weight: 400;
                        font-size: 14px;
                        line-height: 20px;
                        color: white;
                      }
                    } .price:hover{
                            box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
                          }
                       
                             .one{background: linear-gradient(180deg, #1ECBC7 0%, #2BD9A4 100%);} 
                             .two{background: linear-gradient(180deg, #9480DF 0%, #B97FD6 100%);} 
                             .three{background: linear-gradient(180deg, #EEA968 0%, #F2C85E 100%);} 
                             .four{
                              background: linear-gradient(180deg, #EE6B69 0%, #FD8762 100%);}
                                                    

                  }

                 
                  .subscribe__planList{
                    margin-top: 20px;
                    margin-bottom: 40px;

                    .subscribe__planItem{        
                       display: flex;
                       align-items: center;
                       p{
                        color: #5B5971;
                       }
                    }
                  }
                     .subscribe__btn{
                          align-items: center;
                        /* margin-left: 65px;
                        margin-right: 65px; */
                     }

              }
              .subscribe__planGrid:hover{
                            box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
                          }
            
          }

        }
    }
    @media (max-width:992px ) {
          min-width: 900px;
         .subscribe__content{
          .subscribe__plan{
            display: grid;
            grid-template-columns: 2fr 2fr;
            gap: 50px;
            .subscribe__list{
             
             .subscribe__planGrid{

               .subscribe__planList{
                margin: 0 auto ;
                padding: 5px 10px;
                .subscribe__planItem{
                  align-items: center;
                  /* margin-left: 65px; */
                }
               }
               .subscribe__btn{
                margin-left: 65px;
                margin-bottom: 10px
               }
             }
            }
          }
         }
     } 

     @media (max-width:400px ) {
          min-width: 900px;
           
         .subscribe__content{
          .subscribe__plan{
            display: grid;
            grid-template-columns: 1fr;
            .subscribe__list{
             
             .subscribe__planGrid{

               .subscribe__planList{
                margin: 0 auto ;
                padding: 5px 60px;
                .subscribe__planItem{
                  align-items: center;
                  /* margin-left: 65px; */
                }
               }
               .subscribe__btn{
                margin-left: 95px;
                margin-bottom: 10px
               }
             }
            }
          }
         }
     } 


`